import React, { useState, useEffect } from 'react';
import './sideBar.css';
import pro360Logo from '../../../assets/images/pro360.png';
import { NavLink, useLocation } from 'react-router-dom';
import { ReactComponent as DashboardInactive } from '../../../assets/images/svgIcons/DashboardinActive.svg';
import { ReactComponent as Menu } from '../../../assets/images/svgIcons/menu.svg';
import { ReactComponent as Order } from '../../../assets/images/svgIcons/order.svg';
import { ReactComponent as Costumer } from '../../../assets/images/svgIcons/costumer.svg';
import { ReactComponent as Employee } from '../../../assets/images/svgIcons/employee.svg';
import { ReactComponent as Payment } from '../../../assets/images/svgIcons/payment.svg';
import { ReactComponent as MAsterInActive } from '../../../assets/images/svgIcons/Master.svg';
import { ReactComponent as UserRole } from '../../../assets/images/svgIcons/UserRole.svg';
import { Link } from 'react-router-dom';
import { FaPizzaSlice, FaUserClock } from 'react-icons/fa';
import { BiRestaurant } from 'react-icons/bi';
const SideBar = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const location = useLocation();
  const [showUserMasterSubMenu, setShowUserMasterSubMenu] = useState(false);

  return (
    <nav class="navbar navbar-expand-md  fixed-left ">
      <a href="/home" class="navbar-brand center mb-4 mt-3" className="logo">
        <img style={{ height: '39px' }} src={pro360Logo} alt="Logo" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarsExampleDefault"
        aria-controls="navbarsExampleDefault"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse ovrflo" id="navbarsExampleDefault">
        <ul class="navbar-nav">
          <li class="nav-item">
            <NavLink to="/home" className="nav-link align-middle" activeClassName="active">
              {location.pathname === '/home' ? (
                <>
                  <DashboardInactive size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  activetxt">Home</h6>
                  </a>
                </>
              ) : (
                <>
                  <DashboardInactive size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  inactivetxt">Home</h6>
                  </a>
                </>
              )}
            </NavLink>
          </li>
          <li class="nav-item">
            <NavLink to="/admin/menu" className="nav-link align-middle" activeClassName="active">
              {location.pathname === '/admin/menu' ? (
                <>
                  <Menu size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  activetxt">Menus</h6>
                  </a>
                </>
              ) : (
                <>
                  <Menu size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  inactivetxt">Menus</h6>
                  </a>
                </>
              )}
            </NavLink>
          </li>
          <li class="nav-item">
            <NavLink to="/admin/orders" className="nav-link align-middle" activeClassName="active">
              {location.pathname === '/admin/orders' ? (
                <>
                  <Order size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  activetxt">Orders</h6>
                  </a>
                </>
              ) : (
                <>
                  <Order size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  inactivetxt">Orders</h6>
                  </a>
                </>
              )}
            </NavLink>
          </li>
        </ul>
        <ul class="navbar-nav">
          <li class="nav-item">
            <NavLink to="/admin/Payment" className="nav-link align-middle" activeClassName="active">
              {location.pathname === '/admin/Payment' ? (
                <>
                  <Payment size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  activetxt">Payment</h6>
                  </a>
                </>
              ) : (
                <>
                  <Payment size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  inactivetxt">Payment</h6>
                  </a>
                </>
              )}
            </NavLink>
          </li>
          <li class="nav-item">
            <NavLink to="/admin/CustomerList" className="nav-link align-middle" activeClassName="active">
              {location.pathname === '/admin/CustomerList' ? (
                <>
                  <Costumer size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  activetxt">Customer</h6>
                  </a>
                </>
              ) : (
                <>
                  <Costumer size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  inactivetxt">Customer</h6>
                  </a>
                </>
              )}
            </NavLink>
          </li>
          <li class="nav-item">
            <NavLink to="/admin/employee" className="nav-link align-middle" activeClassName="active">
              {location.pathname === '/admin/employee' ? (
                <>
                  <Employee size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  activetxt">Employees</h6>
                  </a>
                </>
              ) : (
                <>
                  <Employee size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  inactivetxt">Employees</h6>
                  </a>
                </>
              )}
            </NavLink>
          </li>
          {/* <li class="nav-item">
                        <NavLink to="/admin/posting" className="nav-link align-middle" activeClassName="active">
                            {location.pathname === "/admin/posting" ? (
                                <>
                                    <IoPushOutline size={25} className="" />
                                    <a className="nav-link align-middle">
                                        <h6 className="d-none d-sm-inline  activetxt">Posting</h6>
                                    </a>
                                </>
                            ) : (
                                <>
                                    <IoPushOutline size={25} className="" />
                                    <a className="nav-link align-middle">
                                        <h6 className="d-none d-sm-inline  inactivetxt">Posting</h6>
                                    </a>
                                </>
                            )}
                        </NavLink>
                    </li> */}
        </ul>
        <ul class="navbar-nav">
          <li class="nav-item">
            <NavLink to="/admin/Company" className="nav-link align-middle" activeClassName="active">
              {location.pathname === '/admin/Company' ? (
                <>
                  <BiRestaurant size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  activetxt">Company</h6>
                  </a>
                </>
              ) : (
                <>
                  <BiRestaurant size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  inactivetxt">Company</h6>
                  </a>
                </>
              )}
            </NavLink>
          </li>
          {/* <li className="nav-item dropdown">
                        <div className={`nav-link align-middle ${location.pathname.startsWith("/admin/Reports/home/") ? "active" : ""}`}>
                            <FaPizzaSlice size={25} />
                            <div className="nav-link align-middle">
                                <h6 className="d-none d-sm-inline">
                                    {location.pathname.startsWith("/admin/Reports/home/") ? "Reports & Analytics" : "Reports & Analytics"}
                                </h6>
                            </div>
                        </div>
                        <div className="dropdown-content-ab">
                            {reportsConfig.map((report) =>
                                // permissions[report.key] ? (
                                <Link to={report.route} className="p-2" key={report.key}>
                                    {report.icon} {report.label}
                                </Link>
                                // ) : null
                            )}
                        </div>
                    </li> */}
        </ul>
        <ul className="navbar-nav">
          <li class="nav-item">
            <NavLink to="/admin/Reports/List" className="nav-link align-middle" activeClassName="active">
              {location.pathname === '/admin/Reports/List' ? (
                <>
                  <FaPizzaSlice size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  activetxt">Reports</h6>
                  </a>
                </>
              ) : (
                <>
                  <FaPizzaSlice size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  inactivetxt">Reports</h6>
                  </a>
                </>
              )}
            </NavLink>
          </li>
          <li class="nav-item">
            <NavLink to="/admin/Master/List" className="nav-link align-middle" activeClassName="active">
              {location.pathname === '/admin/Master/List' ? (
                <>
                  <MAsterInActive size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  activetxt">Master</h6>
                  </a>
                </>
              ) : (
                <>
                  <MAsterInActive size={25} className="" />
                  <a className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline  inactivetxt">Master</h6>
                  </a>
                </>
              )}
            </NavLink>
          </li>
        </ul>
        {/* <ul className="navbar-nav">
          <li className="nav-item dropdown">
            <div className={`nav-link align-middle ${location.pathname.startsWith('/admin/UserManagement/') && !showUserMasterSubMenu ? 'active' : ''}`}>
              {location.pathname.startsWith('/admin/UserManagement/') ? (
                <>
                  <UserRole size={25} className="" />
                  <div className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline activetxt">User Management</h6>
                  </div>
                </>
              ) : (
                <>
                  <UserRole size={25} className=" " />
                  <div className="nav-link align-middle">
                    <h6 className="d-none d-sm-inline inactivetxt">User Management</h6>
                  </div>
                </>
              )}
            </div>
            <div className="dropdown-content-ex">
              <Link to="/admin/UserManagement/userMaster/UserClaim" className="p-2">
                <FaUserClock /> User Claim Master
              </Link>
              <Link to="/admin/UserManagement/userMaster/UserRole" className="p-2">
                <FaUserClock /> User Role
              </Link>
            </div>
          </li>
        </ul> */}
      </div>
    </nav>
  );
};
export default SideBar;
